import { render } from "./ButtonArrowCarouselNext.vue?vue&type=template&id=bdb43ea0&ts=true"
import script from "./ButtonArrowCarouselNext.vue?vue&type=script&lang=ts"
export * from "./ButtonArrowCarouselNext.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__